export enum AddressType {
    Personal = 1,
    Corporate = 2
}
